module.exports = __webpack_public_path__ + "static/img/10.a46013d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/sp/10.png
// module id = 6Gbp
// module chunks = 0